import React from 'react';
import {borderBottomStyle, borderSideStyle} from "./tableStyles";

type Props = {
  dateList: string[]
}

const SimulationTableHead: React.VFC<Props> = (props) => {
  return (
    <tr>
      <th scope='col' rowSpan={2} colSpan={1} className={'px-6 py-2 border-t-gray-500 ' + borderBottomStyle + borderSideStyle }>投手</th>
      <th scope='col' rowSpan={2} colSpan={1} className={'px-6 py-2 border-t-gray-500 ' + borderBottomStyle + borderSideStyle }>チーム</th>
      <th scope='col' rowSpan={2} colSpan={1} className={'px-6 py-2 border-t-gray-500 ' + borderBottomStyle + borderSideStyle }>背番号</th>
      <th scope='col' colSpan={5} className={'px-2 py-2 col-span-2 border-t-gray-500 ' + borderBottomStyle + borderSideStyle }><p>初日</p><p>{props.dateList[0]}</p></th>
      <th scope='col' colSpan={5} className={'px-2 py-2 col-span-2 border-t-gray-500 ' + borderBottomStyle + borderSideStyle }><p>1日後</p><p>{props.dateList[1]}</p></th>
      <th scope='col' colSpan={5} className={'px-2 py-2 col-span-2 border-t-gray-500 ' + borderBottomStyle + borderSideStyle }><p>2日後</p><p>{props.dateList[2]}</p></th>
      <th scope='col' colSpan={5} className={'px-2 py-2 col-span-2 border-t-gray-500 ' + borderBottomStyle + borderSideStyle }><p>3日後</p><p>{props.dateList[3]}</p></th>
      <th scope='col' rowSpan={2} colSpan={1} className={'px-2 py-2 col-span-2 border-t-gray-500 border-l-gray-500 ' + borderBottomStyle + borderSideStyle }><p> </p></th>
    </tr>
  );
};

export default SimulationTableHead;
